import React, { useContext, useEffect, useState } from 'react';
import { Form, Row, Checkbox, DatePicker, Radio, Typography } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { DeleteOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import FormInput from 'components/FormInput';
import GetLabel from 'DisplayFramework/components/GetLabel';
import ButtonLink from 'components/theme_components/ButtonLink';
import Notification from 'components/theme_components/Notifications';
import { AuthContext } from 'components/Auth/Auth';
import { toDatePickerDate } from 'utils/utils2';
import { TpAuthorizationResponse } from 'services/thirdParty';
import Title from 'components/Title';
import ConfirmModal from 'components/theme_components/ThirdParty/ConfirmModal';
export type ControlActivityModalProps = {
  form: FormInstance;
  onDone: any;
  onCancel: any;
  dataInput: TpAuthorizationResponse;
  loading: boolean;
};

const TabUpdateCreditControl = ({
  form,
  onDone,
  onCancel,
  dataInput,
  loading,
}: ControlActivityModalProps) => {
  const { isInspect } = useContext(AuthContext);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    if (dataInput && dataInput.authDetail) {
      form.setFieldsValue({
        authid: dataInput.authid,
        event: 'TabUpdateCreditControl',
        creditcontrol: dataInput.creditcontrol,
      });
    }
  }, [dataInput]);

  const validateFields = () => {
    form.validateFields().then(() => {
      onDone();
    });
  };

  return (
    <div>
      <FormInput
        name="creditcontrol"
        className="form-item no-border-radius"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        labelAlign="left"
        rules={[{ required: true }]}
      >
        <Radio.Group className="ut-radio-group ant-radio-group-flex-end">
          <Radio value="NONE"> Aucun </Radio>
          <Radio value="SYSTEM"> Systématique </Radio>
          <Radio value="BLOCKED"> Bloqué </Radio>
        </Radio.Group>
      </FormInput>

      <Row justify={'end'} style={{ marginTop: 13 }}>
        <ButtonLink
          comcode="Annuler"
          className="ut-btn-bordred"
          onClick={() => !isInspect && onCancel()}
        />
        <ButtonLink
          type="primary"
          comcode="Valider"
          htmlType="submit"
          className="ut-reset-btn"
          loading={loading}
          onClick={() => {
            !isInspect && setModalVisible(true);
          }}
          iconPosition="end"
        />
        <ConfirmModal
          visible={modalVisible}
          status="error"
          message=""
          description="Souhaitez vous modifier le contrôle de crédit en [....] ?"
          onConfirm={() => {
            setModalVisible(false);
            !isInspect && validateFields();
          }}
          onCancel={() => !isInspect && setModalVisible(false)}
          className="modalConfirmOrCancel"
        />
      </Row>
    </div>
  );
};

export default TabUpdateCreditControl;
